import React, {useRef} from 'react';
import '../css/formats.css';
import { useReactToPrint } from "react-to-print";
import { Datos_Empresa, development } from "../libs/utils/Const";

export const FormatQuotationModal = () => {
    const folio = "0000";
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Cotización_'+folio,
        onafterprint: () => alert('Print Success')
    })    
        
    return (
        
        <div>
            <div className="modal fade" id="formatQuotationModal" data-keyboard="true" tabIndex="-1" aria-labelledby="formatQuotationModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-xl" >
                    <div className="modal-content text-responsive">
                        <div className="modal-header">
                            
                        </div>
                        <div ref={componentRef} className="modal-body scrollPage" id="printQuotation">
                            <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto"}}>
                                <div className="row">
                                    <div className="col-3">
                                        <img src={development? require('../images/logo_draft.svg') : require('../images/logo_EMPRESA.svg')} alt="Logo"/>
                                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br/><strong>{Datos_Empresa.RFC}</strong></p>
                                        <span className="text-left">Teléfono(s):</span>
                                        <p>COL. C.P.;,.</p>
                                    </div>
                                    <div className="col-9">
                                        <table>
                                            <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                                <tr>
                                                    <th className="text-left">Cotización</th>
                                                    <th className="text-center">Serie</th>
                                                    <th className="text-center">No. Cliente</th>
                                                    <th className="text-center">Cliente</th>
                                                    <th className="text-center">Fecha</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left">fsf</td>
                                                    <td className="text-center">fsdf</td>
                                                    <td className="text-center">dfsdf</td>
                                                    <td className="text-center">fsdfsd</td>
                                                    <td className="text-center">fsfs</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                                <tr>
                                                    <th className="text-left" colSpan="3">Asesor de ventas</th>
                                                    <th className="text-center">Capturista</th>
                                                    <th className="text-center">Hora</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left" colSpan="3">fsf</td>
                                                    <td className="text-center">fsdf</td>
                                                    <td className="text-center">dfsdf</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                                <tr>
                                                <th className="text-left" colSpan="4">Dirección sucursal:</th>
                                                    <th className="text-center">Moneda</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left" colSpan="4">dfsdf</td>
                                                    <td className="text-center">fsdfsd</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                                <tr>
                                                    <th className="text-left" colSpan="5">Teléfonos:</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left" >fsf</td>
                                                    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='row mt-3' style={{paddingRight:"15px"}}>
                                    <div className='col-12 mb-3 text-center'>
                                        <span><strong>COTIZACION</strong><br/></span>
                                    </div>
                                    <span>Por medio de la presente le cotizamos los siguientes artículos tan amablemente solicitados por usted:</span>
                                    <table>
                                        <thead style={{background: Datos_Empresa.BackgroundColor, color:"white"}}>
                                            <tr>
                                                <th className="text-center">Cant.</th>
                                                <th className="text-center">Ud</th>
                                                <th className="text-center">Código</th>
                                                <th className="text-center">Descripción</th>
                                                <th className="text-center">Precio</th>
                                                <th className="text-center">Importe</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{border: "solid 1px"}}>
                                            <tr>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsdf</td>
                                                <td className="text-center">dfsdf</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsdf</td>
                                                <td className="text-center">dfsdf</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsdf</td>
                                                <td className="text-center">dfsdf</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsdf</td>
                                                <td className="text-center">dfsdf</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsfs</td>
                                                <td className="text-center">fsf</td>
                                                <td className="text-center">fsdf</td>
                                                <td className="text-center">dfsdf</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className='row mt-3' style={{paddingRight:"15px"}}>                                    
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className='text-left' rowSpan={4}>
                                                    <p>
                                                        Importe con letra: VEINTICUATRO MIL OCHOCIENTOS SESENTA Y SIETE PES.<br/>                                                        
                                                        Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración.<br/>
                                                        * Precios Sujetos a Cambio Sin Previo Aviso.<br/>
                                                        ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.<br/>
                                                        *** Maniobras de descarga a cargo del cliente.<br/>
                                                    </p>
                                                </td>
                                                <td className='text-right'><strong>Subtotal: </strong></td>
                                                <td className='text-center' style={{borderLeft: "solid 1px",borderRight: "solid 1px", borderTop: "solid 1px", minWidth:"12.5vw"}}>fsdf</td>
                                            </tr>
                                            <tr>
                                                <td className='text-right'><strong>IVA: </strong></td>
                                                <td className='text-center' style={{borderLeft: "solid 1px",borderRight: "solid 1px"}}>fsdf</td>
                                            </tr>
                                            <tr>
                                                <td className='text-right'><strong>Total: </strong></td>
                                                <td className='text-center' style={{borderLeft: "solid 1px",borderRight: "solid 1px", borderBottom: "solid 1px"}}>fsdf</td>
                                            </tr>
                                            <tr>
                                                <td className='text-right' style={{color: "white"}}>.</td>
                                                <td className='text-center' style={{color: "white"}}>.</td>
                                            </tr>
                                        </tbody>
                                    </table>                                    
                                </div>
                                <div className='row mt-2' style={{paddingRight:"15px"}}>
                                    <div className='col-12'>
                                        <br/>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-center">Atentamente</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br/><br/><br/>
                                        <table>
                                            <tbody>                                                
                                                <tr>
                                                    <td className="text-center">______________________________</td>
                                                    <td className="text-left"></td>
                                                    <td className="text-center">______________________________</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">Gerente de Sucursal</td>
                                                    <td></td>
                                                    <td className="text-center">Asesor de Ventas</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div> 
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={handlePrint}>Imprimir</button>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
    
}

export default FormatQuotationModal;